
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","fill-rule":"evenodd","clip-rule":"evenodd"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.191 9.077l3.627-1.796-3.717-3.17 1.149-.569 6.018 2.031 2.873-1.423c.758-.38 2.01-.278 2.295.296a.702.702 0 01.064.306c-.002.586-.59 1.381-1.221 1.698l-2.875 1.423-2.03 6.016-1.15.569-.268-4.878-3.626 1.796-.749 1.802-.804.398-.281-2.725L.5 8.979l.804-.399 1.887.497z"}})])
          )
        }
      }
    